// extracted by mini-css-extract-plugin
export default {"container":"root_container__AWMyv","content":"root_content__FrFGw","section":"root_section__cYPbq"};